// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
    padding: 6%;
}

.article {
    display: block;
}

.post {
    padding: 3em 3em 1em 3em;
    background: #ffffff;
    border: solid 1px rgba(160, 160, 160, 0.3);
    margin: 0 0 3em 0;
    position: relative;
}

.post > header {
    display: -moz-flex;
    display: -ms-flex;
    display: flex;
    border-bottom: solid 1px rgba(160, 160, 160, 0.3);
    left: -3em;
    margin: -3em 0 3em 0;
    position: relative;
    width: calc(100% + 6em);
}

.post > header .title {
    -moz-flex-grow: 1;
    -ms-flex-grow: 1;
    flex-grow: 1;
    -ms-flex: 1;
    padding: 3.75em 3em 3.3em 3em;
}

h4 a {
    text-decoration: none;
    color: inherit;
    border-bottom: dotted 1px rgba(160, 160, 160, 0.65);
    text-transform: uppercase;
}

h4 a:hover  {
    text-decoration: none;
    color: inherit;
    font-weight: 500;
}

.section {
    margin-bottom: 5%;
}

.section .section-link {
    text-decoration: none;
    color: black;
    font-size: 1.7em;
    margin-right: 2%;
}

.section h6 {
    line-height: 2.5em;
}
.section h6 a {
    text-decoration: none;
    color: black;
    border-bottom: dotted 1px rgba(160, 160, 160, 0.65);
}

.section h6 a:hover {
    text-decoration: none;
    color: black;
}

.inline-flex {
    display: inline-flex;
}
`, "",{"version":3,"sources":["webpack://./src/components/Main/Main.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAElB,iBAAiB;IACjB,aAAa;IACb,iDAAiD;IACjD,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IAEjB,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,mDAAmD;IACnD,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,mDAAmD;AACvD;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":[".main {\n    padding: 6%;\n}\n\n.article {\n    display: block;\n}\n\n.post {\n    padding: 3em 3em 1em 3em;\n    background: #ffffff;\n    border: solid 1px rgba(160, 160, 160, 0.3);\n    margin: 0 0 3em 0;\n    position: relative;\n}\n\n.post > header {\n    display: -moz-flex;\n    display: -webkit-flex;\n    display: -ms-flex;\n    display: flex;\n    border-bottom: solid 1px rgba(160, 160, 160, 0.3);\n    left: -3em;\n    margin: -3em 0 3em 0;\n    position: relative;\n    width: calc(100% + 6em);\n}\n\n.post > header .title {\n    -moz-flex-grow: 1;\n    -webkit-flex-grow: 1;\n    -ms-flex-grow: 1;\n    flex-grow: 1;\n    -ms-flex: 1;\n    padding: 3.75em 3em 3.3em 3em;\n}\n\nh4 a {\n    text-decoration: none;\n    color: inherit;\n    border-bottom: dotted 1px rgba(160, 160, 160, 0.65);\n    text-transform: uppercase;\n}\n\nh4 a:hover  {\n    text-decoration: none;\n    color: inherit;\n    font-weight: 500;\n}\n\n.section {\n    margin-bottom: 5%;\n}\n\n.section .section-link {\n    text-decoration: none;\n    color: black;\n    font-size: 1.7em;\n    margin-right: 2%;\n}\n\n.section h6 {\n    line-height: 2.5em;\n}\n.section h6 a {\n    text-decoration: none;\n    color: black;\n    border-bottom: dotted 1px rgba(160, 160, 160, 0.65);\n}\n\n.section h6 a:hover {\n    text-decoration: none;\n    color: black;\n}\n\n.inline-flex {\n    display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
